import _export from '../internals/export.js';
import objectToArray from '../internals/object-to-array.js';

var $ = _export;
var $values = objectToArray.values; // `Object.values` method
// https://tc39.es/ecma262/#sec-object.values

$({
  target: 'Object',
  stat: true
}, {
  values: function values(O) {
    return $values(O);
  }
});
